/**
 * The page editor's quick window chips: a chip is a real moment, not a string — the clock
 * time it names, today, or tomorrow if today's has already gone by, because a Portal that
 * ended before it started is nonsense.
 */
const CHIP_HOURS = {
  NOW: null, '6:00 PM': 18, '7:00 PM': 19, '8:00 PM': 20,
  '9:00 PM': 21, '10:00 PM': 22, '11:00 PM': 23, MIDNIGHT: 24,
};

export function chipToWindow(label, after = null) {
  const hour = CHIP_HOURS[label];
  if (hour == null) return { label, iso: new Date().toISOString() };
  const d = new Date();
  d.setHours(hour, 0, 0, 0);
  const floor = after ? new Date(after) : new Date();
  if (d <= floor) d.setDate(d.getDate() + 1);
  return { label, iso: d.toISOString() };
}

/** `SAT SEP 26 · 8:30 PM` — the custom chip wears the moment it stands for. */
export function customLabel(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'PICK A DATE';
  const day = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `${day} · ${time}`.toUpperCase();
}
